<template>
  <p v-if="isDisplay(message, anotherCondition)" :class="$className.error">
    {{ message }}
  </p>
</template>

<script setup>
import { useErrorMessage } from '@component_path/inquiry_form_common_module/custom_hook/ErrorMessage.js';
import { useFieldError } from 'vee-validate';

const props = defineProps({
  itemName: {
    type: String,
    required: true
  },
  anotherCondition: {
    type: Boolean,
    default: true
  }
});

const message = useFieldError(props.itemName);
const { isDisplay } = useErrorMessage();
</script>
